export default class Hreflang {
  constructor(el) {
    this.el = el;
    this.cookieDomain = (window.app || {}).cookieDomain || document.location.hostname.replace(/^www\./,'');

    var lang = el.hreflang;
    el.addEventListener('click', (e) => {
        
        var expires = new Date();
        expires.setTime(expires.getTime() + 1000 * 315360000);
        document.cookie = 'preferredLanguage=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT';
        if (window.consent === undefined || window.consent.hasConsented.indexOf('preferences') >= 0) {
            document.cookie = 'preferredLanguage=' + encodeURIComponent(lang) + ';domain=' + this.cookieDomain + ';path=/;max-age=315360000;expires=' + expires.toUTCString();
        }
    }, false);
  }
}
